// extracted by mini-css-extract-plugin
export default {"root":"TT1nEk","small":"sYx3LE","medium":"BWxju8","large":"uVmSdu"};